/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

import typographyStyle from "../../assets/jss/material-dashboard-pro-react/components/typographyStyle.jsx";

function Primary({ classes, children }) {
  return <div className={classes.defaultFontStyle + " " + classes.primaryText}>{children}</div>;
}

Primary.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default withStyles(Primary, typographyStyle);
